<script>
import OneImage from './OneImage.vue'
import { Swiper, SwiperSlide } from "swiper/vue"

import "swiper/swiper-bundle.css"
import "swiper/components/pagination/pagination.min.css"

import SwiperCore, { Pagination, Lazy } from "swiper/core"

SwiperCore.use([Pagination, Lazy])

export default {
  name: "app-smart-catalog-item_images_slider",
  components: {
    Swiper,
    SwiperSlide,
    OneImage,
  },
  props: {
    images: Array,
    isMobileVersion: Boolean
  },
  computed: {
    cutImages() {
      if (this.images && this.images.length < 9) {
        return this.images
      }
      return this.images.slice(0, 8)
    }
  },
  methods: {
    onSwiperInit(swiper) {
      this.swiper = swiper
      swiper.on('activeIndexChange', (sw) => {
        this.activeSlideIdx = sw.realIndex
      })
    },
    onMouseMoveOverSwiper(e) {
      if (this.isMobileVersion) {
        return
      }

      const { target, offsetX } = e
      const slideWidth = target.classList.contains('spinner')
        ? target.parentNode.clientWidth
        : target.width

      const currentSlideNumber = this.swiper.activeIndex
      const slideVirtualWidth = slideWidth / this.cutImages.length
      const slideStartX = slideVirtualWidth * currentSlideNumber
      if (offsetX > slideStartX + slideVirtualWidth) {
        this.swiper.slideNext(1, true)
      } else if (offsetX < slideStartX) {
        this.swiper.slidePrev(1, true)
      }
    },
  },
  data() {
    return {
      swiper: null,
      activeSlideIdx: 0,
    }
  }
}
</script>

<template>
  <swiper
    :pagination="
      isMobileVersion
        ? {
            type: 'fraction',
            renderBullet: (index, className) => `<span class='${className}'></span>`
          }
        : {
            clickable: true,
            renderBullet: (index, className) => `<span class='${className}'></span>`
          }
    "
    :preloadImages="false"
    :lazy="{ preloaderClass: 'spinner-lazy-preloader' }"
    :grabCursor="true"
    @init="onSwiperInit"
    @mousemove="onMouseMoveOverSwiper"
  >
    <swiper-slide
      class="relative overflow-hidden h-80"
      v-for="(image, imageIdx) in cutImages"
      :key="image"
    > 
      <one-image
        :activeSlideIdx="activeSlideIdx"
        :galleryIdx="imageIdx"
        :image="image"
      />
    </swiper-slide>
    <swiper-slide
      v-if="!cutImages.length"
      class="relative overflow-hidden h-80"
      :key="'image'"
    >
      <span
        class="image-cover"
        :style="{ backgroundImage: `url('https://io.winwinapp.ru/images/Photo.png')` }"
      ></span>
      <img
        class="relative w-full h-full object-contain"
        :src="'https://io.winwinapp.ru/images/Photo.png'"
      />
    </swiper-slide>
  </swiper>
</template>

<style>
.image-cover {
  position: absolute;
  display: block;
  top: -13px;
  left: -13px;
  right: -13px;
  bottom: -13px;
  background: no-repeat center;
  background-size: cover;
  -webkit-filter: blur(13px);
  filter: blur(13px);
  opacity: 0.4;
}
.swiper-pagination-bullet {
  width: 20px;
  height: 3px;
  border-radius: 0%;
  background: rgba(0, 0, 0, 0.2);
}
.swiper-pagination-bullet-active {
  color: #fff;
  background: #007aff;
}
.swiper-pagination-fraction {
  bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  font-size: 0.7rem;
  font-weight: bold;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  width: 5vh;
  height: 3vh;
  left: 50%;
  transform: translate(-50%, -50%);
}
.swiper-slide {
  -webkit-transform: translate3d(0, 0, 0) !important;
}
</style>
